export enum QueryKey {
  setProfile = 'setProfile',
  setCredentials = 'setCredentials',
  setNotifications = 'setNotifications',
  putUserLoginPreferences = 'putUserLoginPreferences',
}
